import * as React from 'react'
import { SVGProps } from 'react'

const SvgSearchIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 19 19' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M9.104 16.625a7.52 7.52 0 1 0 0-15.042 7.52 7.52 0 0 0 0 15.042Z'
      fill={props.fill ? props.fill : '#7C849B'}
    />
    <path
      d='M16.705 18c-.332 0-.663-.13-.903-.369L12.373 14.2a1.303 1.303 0 0 1 0-1.826 1.301 1.301 0 0 1 1.825 0l3.429 3.43c.497.499.497 1.31 0 1.827a1.36 1.36 0 0 1-.922.369Z'
      fill={props.fill ? props.fill : '#7C849B'}
    />
    <circle cx={9} cy={9} r={5} fill='#FAFAFA' />
  </svg>
)

export default SvgSearchIcon
